import { Typography } from '@mui/material';
import { fetchGroupsAction } from 'redux/slices/groupSlice';
import CustomSelectWithInfiniteScroll from '../../../common/components/CustomSelectWithInfiniteScroll';

const SelectGroups = (props) => {
    const { fetchAction, ...rest } = props;
    return (
        <CustomSelectWithInfiniteScroll
            {...rest}
            type="group"
            fetchAction={fetchAction || fetchGroupsAction}
            label={(item) => (
                <>
                    {item.name}
                    &nbsp;
                    {item?.externalId ? <Typography>( {item?.externalId} )</Typography> : null}
                </>
            )}
            i18nKeys={{
                searchPlaceholder: 'iCalendar.filter.searchGroups',
                allItems: 'iCalendar.filter.allGroups',
            }}
        />
    );
};

export default SelectGroups;
